import BaseQueryParameters from './BaseQueryParameters.js';
import DataReferenceQueryPatternType from '../DataReferenceQueryPatternType.js';
/**
 * @memberof data-references
 * @extends data-references.BaseQueryParameters
 * @property {number[]} characteristic_types
 * @property {string[]} dimensions
 * @property {string[]} categories
 * @property {number} ndim
 * @property {string} statistical_type
 * @property {string} time_group
 * @property {string} time_element
 * @property {string} time_context
 * @property {string} start
 * @property {string} end
 * @property {string} sort
 * @property {number} offset
 * @property {number} limit
 */
class SystemQueryParameters extends BaseQueryParameters {
}
SystemQueryParameters.PATTERN_TYPE = DataReferenceQueryPatternType.SYSTEM;
export default SystemQueryParameters;
